import { Done, PriorityHigh, UndoOutlined } from '@mui/icons-material';
import IconAvatar from 'components/icon-avatar/icon-avatar.component';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'util/currency';
import TimelineEvent from '../timeline-event/timeline-event.component';

const Timelines = ({ event, chargeAmount, currency }) => {
  const { t } = useTranslation();

  switch (event.type) {
    case 'PAYMENT_SUCCESS':
      return (
        <TimelineEvent
          createdDate={event.createdDate}
          text={t('drawer.transactionDrawer.timeline.events.paymentSuccess')}
          icon={
            <IconAvatar severity="success" width="24px" height="24px">
              <Done sx={{ fontSize: '18px' }} />
            </IconAvatar>
          }
        />
      );

    case 'REFUND_SUCCESS':
      const { createdDate, refundAmount, refundReason } =
        event.refundDetails ?? {};
      return (
        <TimelineEvent
          createdDate={createdDate}
          text={
            chargeAmount === refundAmount
              ? t('drawer.transactionDrawer.timeline.events.refunded')
              : t('drawer.transactionDrawer.timeline.events.partiallyRefunded')
          }
          amount={formatCurrency(refundAmount, currency)}
          description={t('drawer.transactionDrawer.timeline.events.reason', {
            reason: refundReason,
          })}
          icon={
            <IconAvatar severity="warning" width="24px" height="24px">
              <UndoOutlined sx={{ fontSize: '18px' }} />
            </IconAvatar>
          }
        />
      );

    case 'REFUND_PENDING':
      return (
        <TimelineEvent
          createdDate={event.createdDate}
          text={t(
            'drawer.transactionDrawer.timeline.events.refundPending.label',
          )}
          description={t(
            'drawer.transactionDrawer.timeline.events.refundPending.reason',
          )}
          icon={
            <IconAvatar severity="warning" width="24px" height="24px">
              <UndoOutlined sx={{ fontSize: '18px' }} />
            </IconAvatar>
          }
        />
      );

    case 'REFUND_FAILURE':
      return (
        <TimelineEvent
          createdDate={event.createdDate}
          text={t('drawer.transactionDrawer.timeline.events.refundFailed')}
          description={t('drawer.transactionDrawer.timeline.events.reason', {
            reason: event?.failureDetails?.failureMessage,
          })}
          icon={
            <IconAvatar severity="error" width="24px" height="24px">
              <UndoOutlined sx={{ fontSize: '18px' }} />
            </IconAvatar>
          }
        />
      );

    case 'PAYMENT_FAILURE':
      return (
        <TimelineEvent
          createdDate={event.createdDate}
          text={t('drawer.transactionDrawer.timeline.events.paymentFailed')}
          description={t('drawer.transactionDrawer.timeline.events.reason', {
            reason: event?.failureDetails?.failureMessage,
          })}
          icon={
            <IconAvatar severity="error" width="24px" height="24px">
              <PriorityHigh sx={{ fontSize: '18px' }} />
            </IconAvatar>
          }
        />
      );

    default:
      return null;
  }
};

export default Timelines;
